import React from 'react';
import ItemsList from './ItemsList';
import { Language } from '../../../types/pageBuilder';

interface StatisticsEditorProps {
  sectionId: number;
  language: Language;
  onItemsChange: () => void;
}

/**
 * Statistics editor - uses ItemsList with stat type
 */
const StatisticsEditor: React.FC<StatisticsEditorProps> = ({
  sectionId,
  language,
  onItemsChange,
}) => {
  return (
    <div>
      <ItemsList
        sectionId={sectionId}
        itemType="stat"
        language={language}
        onItemsChange={onItemsChange}
      />
    </div>
  );
};

export default StatisticsEditor;
